module.exports = __webpack_public_path__ + "static/2_education-a89533ca37ae68aff77c933151138f06.png";